import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';

import { fallbackFlagsPreprod } from '../Constants/fallbackFlags_preprod';
import { fallbackFlagsProd } from '../Constants/fallbackFlags_prod';

const environment = `${process.env['NX_DCV2_UI_ENVIRONMENT']}`;

export async function getOptimizelyFlags(urlKey: string, sessionId: string, custKey: string) {
  try {
    const headers = new Headers();

    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', `Bearer ${custKey}`);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}getAllExistingFeatureFlags`;
    console.debug('Optimizely API URL:', URI);
    console.debug('NX_DCV2_API_BASE_URL:', process.env['NX_DCV2_API_BASE_URL']);
    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });

    // Check if the status code is not in the range of 200 to 299
    if (!response.ok) {
      console.warn(`Optimizely API returned status ${response.status}, using fallback flags`);
      throw new Error(`HTTP status code ${response.status}`);
    }

    // Check content type before parsing as JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.warn(`Optimizely API returned non-JSON response (${contentType}), using fallback flags`);
      throw new Error(`Invalid content type: ${contentType}`);
    }

    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;
    const responseCollection = _get(responseData, 'response', []);

    if (responseCollection) {
      console.log('Optimizely feature flags loaded successfully');
      return responseData;
    } else {
      console.warn("Optimizely response missing 'response' collection, using fallback flags");
      return { error, statusCode, message };
    }
  } catch (error) {
    console.error('getOptimizelyFlags:error', error);
    console.log(`Environment when error occurred in retrieval of feature flags: ${environment}`);
    const fallbackFlags = environment === 'prod' ? fallbackFlagsProd : fallbackFlagsPreprod;
    console.log('Using fallback flags:', fallbackFlags);
    return fallbackFlags;
  }
}
